type EventCallback = (data?: any) => void;

export default class EventEmitter {
    private events: { [key: string]: EventCallback[] } = {};

    on(event: string, callback: EventCallback) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(callback);
    }

    protected emit(event: string, data?: any) {
        const eventListeners = this.events[event];
        if (eventListeners) {
            eventListeners.forEach(callback => callback(data));
        }
    }
}